<template>
  <div>
    <div class="box-top">
      <div class="box-top-l">
        <div class="title-b">
        <p>考试人数</p>
        <div class="off">
        </div></div>
        <div v-if="showS" class="cont-ec" id="cont-ec"></div>
      </div>
      <div class="box-top-m">
        <div class="title">月考试次数</div>
        <div class="box-top-m-b">
          <img style="width: 33vh;
    height: 33vh;" src="../../../../assets/image/new/eductionCount.png" alt="">
          <div class="cishu">{{num}}/次</div>
        </div>
      </div>
      <div class="box-top-r">
        <div class="title">年度考试占比</div>
        <div class="cont-ec1" id="cont-ec1">
          
        </div>
      </div>
    </div>
    <div class="table">
      <div class="table-title">
      
                    <div class="inputA">日期
                       <div style="width:80%">
                         <el-date-picker
                        type="date"
                        v-model="examTime"
                        @change="getList"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                       </div>
                    </div>
        <span class="button" @click="getList">查询</span>
      </div>
      <el-table 
          height="67vh"
          :data="listData"
          :header-cell-style="{height:'48px',color:'#909399'}">
        <el-table-column width="100" label="序号">
          <template slot-scope="scope">
            <span>{{(pageNum-1)*pageSize+scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{scope.row.personName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="所属单位">
          <template slot-scope="scope">
            <span>{{scope.row.projectName}}</span>
          </template>
        </el-table-column>
        <el-table-column width="320" label="考试分数">
          <template slot-scope="scope">
            <span>{{scope.row.examScore}}</span>
          </template>
        </el-table-column>
             <el-table-column width="320" label="是否通过">
          <template slot-scope="scope">
            <span>{{scope.row.qualifiedFlag==0?'未通过':'通过'}}</span>
          </template>
        </el-table-column>
          
          
         
       
   
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="addFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="500px"
    >
        <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        >
          <el-form-item label="选择节点：">
            <el-cascader
              v-model="nodeVal"
              :options="nodeOpts"
              :props="props"
              collapse-tags
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="计划开始日期：">
            <el-date-picker
              v-model="addForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="计划完成日期：">
            <el-date-picker
              v-model="addForm.completeTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow()" style="background-color: #4D6EB1;">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import util from '../../../../untils/util'
  import myHttp from '../../../../untils/port'
  import base from '../../../../untils/base'
  export default {
    data() {
      return {
        listData: [],
        groupId: '',
        nodeOpts:[],//级联列表
        props: { value: 'id',label:'nodeTypeName',children:'childList' },//级联
        dataText: '数据加载中...',
        nodeVal:[], //选中节点列表
        //弹出框
        dialogTitle:'',
        addFormVisible:false,
        addForm:{
          projectNodeId:'',//id
          projectId:'',
          sysNodeId:'',
          parentNodeId:'',
          completeTime:'',
          startTime:''
        },
        labelPosition:'right',
        info:{allDay:'0',progress:0,setmentProgress:0},
        flag:false,
        showS:true,
        num:0,
        pageSize:20,
        pageNum:1,
        name:'',
        examTime:'',
        total:0
        }
        
    },
    created() {
      this.groupId = this.$store.state.groupId
    },
    mounted(){
      // this.getData()
      this.getWxData()
      this.getList()
    },
    methods:{
      entList(item){
        console.log(item)
        this.$router.push({
          path:'/newLookList',
          query:{
            data:JSON.stringify(item)
          }
        })
      },
      handleSizeChange(val){
        this.pageSize = val
        this.pageNum = 1
        this.getList()
      },
      handleCurrentChange(val){
        this.pageNum = val
        this.getList()
      },
      async getList(){
        const data=await myHttp.examPerosnDetail({
          projectId:this.groupId,
          examTime:this.examTime,
          paperId:"",
         pageSize: this.pageSize,
         pageNum:this.pageNum,
          type:'1'
        })

          this.listData=data.data.data.list.data
          this.total=data.data.data.list.totalCount
          console.log('表格总数=====》',data.data);
          console.log('表格信息===》',this.listData);
          
        
        console.log('考试详情列表===》',data);
      },
      // getList(){
      //   let that = this
      //   myHttp.paperStatisNew({
      //     groupId: this.groupId,
      //     pageSize:this.pageSize,
      //     pageNum:this.pageNum,
      //     name:this.name,
      //     startTime:this.examTime
      //   }).then(res=>{
      //     that.listData = res.data.list
      //       that.total = res.data.total
      //     console.log(res)
      //   })
      // },
   async   getWxData(){
const data=await myHttp.everydayExamPerson({
  projectId:this.groupId
})
if (data.data.code==200) {
//  一周的数据
  let list=data.data.data.weekExam

  console.log('接口返回数据=====》',data);
  let dataList=[]
  let dateList=[]
for (let index = 0; index < list.length; index++) {
  const element = list[index];
  dateList.push(element.date)
  dataList.push(element.personCount)


}
  dateList=dateList.reverse()
  dataList=dataList.reverse()
  this.echarts1(dataList,dateList)
// 季度数据
 let listB=data.data.data.quarterExam
 let ArryB=[]
 for (let index = 0; index < listB.length; index++) {
  const element = listB[index];
  console.log(element);
  let obj={
    name:Object.keys(element)[0],
    value:Object.values(element)[0]
  }
  ArryB.push(obj)
 }

 this.echarts2(ArryB)
//  月考试次数
this.num=data.data.data.monthExamCount



}
console.log('无锡每日考试人数===》',data);
      },
      // getData(){
      //   myHttp.examEverydayStatis({
      //     groupId:this.groupId
      //   }).then(res=>{
      //     console.log(res)
      //     if(res.data.code==200){
      //       let list = res.data.data.dayExam
      //       list = list.reverse()
      //       let listDate = []
      //       let listData = [
      //       ]
      //       let data = []
      //       list.forEach((item,index)=>{
      //         for(let key in item){
      //           listDate.push(key)
      //           listData.push(item[key])
      //         }
      //       })
      //       listData.forEach((item,index)=>{
      //         data.push(item.qualified+item.unqualified)
      //       })
      //       console.log(listDate)
      //       console.log(listData)
      //       console.log(data)
      //       this.num = res.data.data.monthExamCount
            
      //       let b = []
      //       let a = res.data.data.quarter[0]
      //       for(let key in a){
      //         b.push({value:a[key],name:key})
      //       }
      //       // this.echarts1(listDate,listData,data)
      //       this.echarts2(b)
      //     }
      //   })
      // },
      echarts2(itemSt){
            let chartDom1 = document.getElementById('cont-ec1');
            let myChart1 = this.$echarts.init(chartDom1);
            myChart1.setOption({
                color:['#0d3a95','#4d7bd8','#8394b5','#34579d'],
                series: [
                    {
                      label: {
                show: true,
                position: "inner",
                formatter: function (params) {
                  console.log(params)
                    if(params.data.value == 0){
                    params.data.value=''
                    return ''
                    }else{
                    return params.data.name+params.data.value + '%'
                    }
              },
                      },
                    name: 'Nightingale Chart',
                    type: 'pie',
                    radius: [0, '80%'],
                    center: ['50%', '50%'],
                    roseType: 'radius',
                    itemStyle: {
                        borderRadius: 0
                    },
                    data: itemSt
                    }
                ]
            });
            window.addEventListener("resize", () => {
          // 自动渲染echarts
          myChart1.resize();
        });
        },
      echarts1(dataA,dateA){
        const that=this
console.log('进入图表函数====》',dataA,dateA);

        let chartDom = document.getElementById('cont-ec');
        let myChart = this.$echarts.init(chartDom);
          myChart.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: function(params){
              console.log(params)
              let result = '<div style="color:#2BC7FB">'+'总人数'+dataA[params[0].dataIndex]+'</div>'
                            return result
              // if(params.length>0){
              //   let result = params[0].name + "<br>";
              //   params.forEach(function (item){
              //     //item.value
              //     if (true) {
              //       result +=
              //         item.marker +
              //         " " +
              //         item.seriesName +
              //         " : " +
              //         item.value +'%'+
              //         "</br>";
              //     } else if (item.seriesName == "完成进度") {
              //       result +=
              //         item.marker +
              //         " " +
              //         item.seriesName +
              //         " : " +
              //         item.value +
              //         "%</br>";
              //     }
              //   })
              //       return result;
              // }
            }
          },
          width:'83%',
          // legend: {
          //   orient: 'vertical' ,
          //   data: dateA,
          //   right:'0',
          //   top:'10%'
          // },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          
          color:['#2BABF0'],
          xAxis: {
            axisLine: {
                    lineStyle: {
                      type: 'solid',
                      color: '',
                      width: '1'
                    }
                  },
            type: 'category',
        splitLine:{
                    show: true, //让网格显示
                    lineStyle: {//网格样式
                      color:['#07DBFF'], //网格的颜色
                      width:1, //网格的宽度
                      type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                    }
                  },
            boundaryGap: false,
            data: dateA,
          },
          yAxis: {
            axisLabel:{
              show:true,
              interval:'auto',
              // formatter:'{value}%'
            },
            // min:0,
            // max:100,
           
			scale : true,
            splitNumber : 5,
            type: 'value',
            splitLine:{
              show: true,
              lineStyle: {
                color:['#07DBFF'],
                width:1,
                type:'dashed'
              }
            },
          },
          series: {
              type: 'line',
              data: dataA,
              itemStyle: {
                      normal: {
                        areaStyle: {
                          type: "default",
                          opacity: 0.2
                        },
                      },
                    },
            }
        })
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          myChart.resize();
        });
          myChart.on('click', function (params) {
         console.log('监听到图表被点击===》',params.name);
         that.examTime=params.name
         that.getList()
              
              })
      }
    }
  }
</script>

<style scoped>
.box-top{
  height: 48.5vh;
  margin-bottom: 8px;
  display: flex;
}
.box-top-l{
  height: 48vh;
    width: 46.7vw;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
}
.box-top-m{
  height: 48vh;
    width: 19vw;
  border-radius: 6px;
background: #fff;
box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
  margin-left: 8px;
}
.box-top-m-b{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 10%;
  padding-top: 10%;
  position: relative;
}
.cishu{
  font-family: SourceHanSansCN-Regular;
font-size: 40px;
font-weight: normal;
letter-spacing: 0em;
color: #409BCB;
text-shadow: 0px 2px 10px 0px rgba(46, 173, 242, 0.4);
position: absolute;
left: 36%;
    bottom: 29%;
}
.box-top-r{
  height: 48vh;
    width: 22vw;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
  margin-left: 8px;
}
.title{
  height: 6vh;
  padding-left: 0.9vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #E7E7E7;
}
.title-b{
  height: 6vh;
padding-left: 0.9vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #E7E7E7;
}




.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table{
  min-height: 80vh;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.table-title{
  text-align: right;
  padding: 12px 16px;
  border-bottom: 2px solid #E7E7E7;
  display: flex;
  align-items: center;
  justify-content: end;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: 'SourceHanSansCN-Regular';
  font-size: 14px;
  cursor: pointer;
}
.button-red:hover{
  background-color: #F56C6C;
  color: #fff!important;
}
.cont-ec{
  width: 46.7vw;
    height: calc(100% - 6vh);
    
    background-color: #fff;
}
.cont-ec1{
  width: 21vw;
    height: 41.7vh;

}
.off{
  width: 8vw;
  margin-right: 6%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputA{
    width: 18%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
margin-left:.5208vw
}
.inputA ::v-deep .el-input__inner{
    width: 90% !important;
    height: 36px !important;
}

::v-deep.el-table th.el-table__cell>.cell{
    font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #909399
}
::v-deep.el-table td.el-table__cell div{
font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
}
</style>